import PropTypes from 'prop-types';

const financialAssistanceReferralDetailsPropType = PropTypes.shape({
    status: PropTypes.string.isRequired,
    fileApplication: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    applicationSubmission: PropTypes.instanceOf(Date),
    programId: PropTypes.number,
    programName: PropTypes.string,
    followUpPhone: PropTypes.string,
    effectiveStartDate: PropTypes.instanceOf(Date),
    effectiveEndDate: PropTypes.instanceOf(Date),
    amountFunded: PropTypes.number,
    otherAssistance: PropTypes.string,
    fundingSource: PropTypes.shape({
        id: PropTypes.string,
    }),
    isCoveringMedicationCost: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    isReEnrollmentRequired: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    scheduleFollowUpActivity: PropTypes.bool,
    followUpScheduleOption: PropTypes.string,
    followUpDueDate: PropTypes.string,
    denialReason: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    notes: PropTypes.string,
});

export default financialAssistanceReferralDetailsPropType;
